<template>
	<div>
    <van-col span="22" offset="1">
      <!-- 更换头像 -->
      <van-col span="24" class="my_information">
        <van-image round width="7em" height="7em" :src="user.avatar" fit="cover" v-if="user.avatar" @click="img_upload"/>
        <img src="../assets/img/avatar.png" class="avatar2" @click="img_upload" v-else>
        <van-col span="24" class="avatar2-text" v-if="!user.avatar">{{ $t('user.Head_portrait_open') }}</van-col>
      </van-col>
      <!-- 昵称 -->
      <van-col span="24" class="my_information_type my_information_top">
          <van-cell-group>
            <van-field v-model="user.user_nickname" label-width="120px" :label="$t('user.Nickname')" is-link/>
          </van-cell-group>
      </van-col>
      <!-- 性别-->
      <van-col span="24" class="my_information_type">
        <van-cell required  :title="$t('user.Gender')" @click="show = true" :value="user.sex | getsex(this,$t) " is-link/>
        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>
      <!-- 年龄 -->
      <van-col span="24" class="my_information_type">
        <van-cell required  :title="$t('user.ages')" @click="showage = true" :value="user.age" is-link/>
        <van-action-sheet v-model="showage">
          <van-picker
            :title="$t('user.ages')"
            show-toolbar
            :columns = 'options_age'
            @confirm = 'onConfirmAge'
            @cancel = 'onChangeAges'
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 城市 -->
      <van-col span="24" class="my_information_type">
        <van-cell required  :title="$t('user.Location')" @click="showcity = true" :value="user | getcity" is-link/>
        <van-action-sheet v-model="showcity">
          <van-picker
            :title="$t('user.address')"
            show-toolbar
            :columns="options7"
            @confirm="onConfirmcity"
            @cancel="onChangecitys"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 身高 is_user_height -->
     <!-- <van-col span="24" class="my_information_type">
        <van-cell :required="config.is_user_height === '1' ? 'required' : false" :title="$t('user.height')" @click="showheight = true" :value="user.height" is-link />
        <van-action-sheet v-model="showheight">
          <van-picker
            :title="$t('user.height')"
            show-toolbar
            :columns="options_height"
            @confirm="onConfirmheight"
            @cancel="onChangeheights"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>-->
      <!-- 学历 -->
    <!--  <van-col span="24" class="my_information_type">
        <van-cell :required="config.is_user_diploma === '1' ? 'required' : false" :title="$t('user.education')" @click="showdiploma = true" :value="user.diploma" is-link/>
        <van-action-sheet v-model="showdiploma" :actions="options1" @select="ondiploma" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>-->
      <!-- 月收入 -->
    <!--  <van-col span="24" class="my_information_type">
        <van-cell :required="config.is_user_monthly_income === '1' ? 'required' : false" :title="$t('user.monthly_income')" @click="showincome = true" :value="user.monthly_income" is-link/>
        <van-action-sheet v-model="showincome" :actions="income_array" @select="onincome" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>-->
      <!-- 婚姻状况 -->
    <!--  <van-col span="24" class="my_information_type">
        <van-cell :required="config.is_user_marriage === '1' ? 'required' : false" :title="$t('user.marital_status')" @click="showmarriage = true" :value="user.marriage" is-link/>
        <van-action-sheet v-model="showmarriage" :actions="options2" @select="onmarriage" :cancel-text="$t('btn.cancel')" close-on-click-action/>
      </van-col>-->
      <!-- 职业 -->
     <!-- <van-col span="24" class="my_information_type">
        <van-cell :required="config.is_user_professional === '1' ? 'required' : false" :title="$t('user.occupation')" @click="showprofessional = true" :value="user.professional" is-link/>
        <van-action-sheet v-model="showprofessional">
          <van-picker
            :title="$t('user.occupation')"
            show-toolbar
            :columns="options6"
            @confirm="onConfirmprofessional"
            @cancel="onChangeprofessionals"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>-->
      <van-col span="24" class="my_information_center">{{ $t('user.Personal_data_modification')}}</van-col>
      <van-col span="18" offset="3">
        <van-button type="primary" size="large" class="my_information_btn" @click="submits" safe-area-inset-bottom>{{ $t('btn.next_step')}}</van-button>
      </van-col>
      <van-overlay :show="is_loading" style="background-color: rgba(0,0,0,0.5);">
        <van-loading type="spinner" color="#ffffff" style="margin-top:50vh"/>
      </van-overlay>
    </van-col>
	</div>
</template>
<script src="https://unpkg.com/element-ui/lib/index.js"></script>
<script>
  import '@/assets/css/style.css'
	import axios from 'axios'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import {Overlay, Toast, Loading} from 'vant';

  export default {
    filters: {
      getsex (sex,t) {
        return sex === 1 ? t.$t('user.sex1') : t.$t('user.sex2')
      },
      getcity (u) {
        return u.province +' '+ u.city
      }
    },
		data() {
			return {
        is_loading: false,
        showprofessional: false,
        showmarriage: false,
        showincome: false,
			  showdiploma: false,
        showheight: false,
        showcity: false,
        showage: false,
			  show: false,
				user: {
					"user_nickname":"",  // 用户昵称
          'sex':'1',
          "avatar":"",       // 用户头像
          "height":'',       // 身高
          "age":'',          // 年龄
          "diploma":"",      // 学历
          "marriage":"",      // 婚姻状况
          "monthly_income":"", // 月收入
          "professional":"",  // 职业
          "signature":"",   // 交友心声
          "province" :'',   // 省
          "city" :'',        // 市
          "user_img":[],      // 照片墙
          "sex2":"1",
				},
        actions: [{ name: this.$t('user.sex1'), value: 1 }, { name: this.$t('user.sex2'), value: 2 }],
        options1: [],
        options2: [],
        options_age:[],
        options_height:[],
				income_array: [],
				options6: [],
				options7: [],             // {value: 'zhinan',label: '指南', children: [{value: 'shejiyuanze',label: '设计原则'}]},
        config: {}
			};
		},
		created: function() {
			this.professional_income()
      this.region_list()
			this.convert()
			document.title = this.$t('title.edit_information')
		},
    components: {
      [Overlay.name]: Overlay,
      [Loading.name]: Loading
    },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.getValueFromApp = this.getValueFromApp
    },
		methods: {
      img_upload () {
        // 上传头像
        this.mobile_intercept()
      },
      mobile_intercept() {
    //    this.is_loading = true
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.upload_avatar.postMessage('avatar')
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.upload_avatar('avatar')
        }
      },
      getValueFromApp(name,url) {
        // 上传回调
        // 下载完成回调(ios和android调用接口)
        if (name === 'avatar') {
          this.user.avatar = url
        }
    //    this.is_loading = false
      },
      onSelect (item) {
        // 默认情况下点击选项时不会自动收起 可以通过 close-on-click-action 属性开启自动收起
        this.user.sex = item.value
        this.show = false
      },
      onConfirmAge (val) {
        // 年龄确认
        this.user.age = val
        this.showage = false
      },
      onChangeAges () {
        this.showage = false
      },
      onConfirmcity (val) {
        // 地址确认
        this.user.province = val[0]
        this.user.city = val[1]
        this.showcity = false
      },
      onChangecitys () {
        this.showcity = false
      },
      onConfirmheight (val) {
        // 身高确认
        this.user.height = val
        this.showheight = false
      },
      onChangeheights () {
        this.showheight = false
      },
      ondiploma (item) {
        // 学历
        this.user.diploma = item.name
        this.showdiploma = false
      },
      onincome (item) {
        // 月收入
        this.user.monthly_income = item.name
        this.showincome = false
      },
      onmarriage (item) {
        // 婚姻状况
        this.user.marriage = item.name
        this.showmarriage = false
      },
      onConfirmprofessional (val) {
        // 职业确认
        this.user.professional = val[1]
        this.showprofessional = false
      },
      onChangeprofessionals () {
        this.showprofessional = false
      },
			convert: function() {
        let i;
        this.options_age = []
        this.options_age.push(this.$t('user.AgedeFault'))
        for(i = 18; i <=70; i++) {
          this.options_age.push(i)
        }
        this.options_height = []
        for(i = 133; i <=199; i++) {
          this.options_height.push(i)
        }
				var uid = this.$route.query.uid;
				var token = this.$route.query.token;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_get_user_information", {
					params: {
						uid: uid,
						token: token
					}
				}).then(res => {
					if(res.data.code == 1){
						this.user.user_nickname = ''
						this.user.avatar = res.data.default_avatar
						this.user.height = res.data.data.height ? res.data.data.height :''
						this.user.age = res.data.data.age ? res.data.data.age : ''
            this.user.age = this.user.age === 0 ? this.$t('user.AgedeFault') : this.user.age
						this.user.diploma = res.data.data.diploma?res.data.data.diploma:''
						this.user.marriage = res.data.data.marriage?res.data.data.marriage:''
						this.user.monthly_income = res.data.data.monthly_income?res.data.data.monthly_income:''
						this.user.professional = res.data.data.professional?res.data.data.professional:''
						this.user.city = res.data.data.city?res.data.data.city:''
						this.user.province = res.data.data.province?res.data.data.province:''
						this.user.sex = res.data.data.sex === 1 ? 1 : 2
					}
				})
			},
      // 城市
      region_list() {
        this.options7 = []
        //    const appData = require('../../city.json') // 加载本地数据文件
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_region_list", { params: { uid: uid,token: token}}).then(res => {
          console.log(res.data.data)
          let appData = res.data.data
          for(let i= 0;i< appData.length; i++){
            const professional_list = appData[i].cities
            const  children =[]
            for(let s=0; s < professional_list.length; s++){
              children[s] ={ text: professional_list[s]['areaName'],label: professional_list[s]['areaName']}
            }
            this.options7.push({'text': appData[i]['areaName'],'label': appData[i]['areaName'],'children': children})
          }
          console.log(this.options7)
        })
      },
			professional_income() {
				const uid = this.$route.query.uid;
				const token = this.$route.query.token;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/professional_income", {
					params: {
						uid: uid,
						token: token
					}
				}).then(res => {
					this.income_array = []
          console.log(res.data.data)
          const incomearr= res.data.data.income
          for(let i= 0;i< incomearr.length; i++){
            const income = {'name': incomearr[i]['name'] }
            this.income_array.push(income)
          }
          // 婚姻
          this.options2 = []
          const marriage= res.data.data.marriage
          for(let i= 0;i< marriage.length; i++){
            const marriage_name = {'name': marriage[i]['name'] }
            this.options2.push(marriage_name)
          }
          // 学历
          this.options1 = []
          const education= res.data.data.education
          for(let i= 0;i< education.length; i++){
            const education_name = {'name': education[i]['name'] }
            this.options1.push(education_name)
          }
					const professional =res.data.data.professional
					this.options6 =[]
					if(professional){
						for(let i= 0;i< professional.length; i++){
							const professional_list = professional[i].professional_list
					        const  children =[]
							for(let s=0; s < professional_list.length; s++){
								children[s] ={ text: professional_list[s]['name'],label: professional_list[s]['name']}
							}
							this.options6.push({'text': professional[i]['name'],'label': professional[i]['name'],'children': children})
						}
					}
					// 获取必填选项
          this.config['is_user_height'] =res.data.data.is_user_height;
          this.config['is_user_diploma'] =res.data.data.is_user_diploma;
          this.config['is_user_monthly_income'] =res.data.data.is_user_monthly_income;
          this.config['is_user_marriage'] =res.data.data.is_user_marriage;
          this.config['is_user_professional'] =res.data.data.is_user_professional;
          this.config['is_user_children'] =res.data.data.is_user_children;
          this.config['is_user_shape'] =res.data.data.is_user_shape;
          this.config['is_user_signature'] =res.data.data.is_user_signature;
				})
      },
			submits: function(){
        this.is_loading = true
				const uid = this.$route.query.uid
				const token = this.$route.query.token
        if(!this.user.city){
          Toast(this.$t('Tips.Choose_location'))
          return false
        }
        if(!this.user.age){
          Toast(this.$t('Tips.Select_age'))
          return false
        }
        if(!this.user.sex){
          Toast(this.$t('Tips.Choose_gender'))
          return false
        }
        const age = this.user.age === this.$t('user.AgedeFault') ? 0 : this.user.age
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_perfect_information", {
					params: {
						uid: uid,
						token: token,
						sex:this.user.sex,
						user_nickname:this.user.user_nickname,
						avatar:this.user.avatar,
						height:this.user.height,
						age: age,
						diploma:this.user.diploma,
						marriage:this.user.marriage,
						monthly_income:this.user.monthly_income,
						professional:this.user.professional,
						province:this.user.province,
						city:this.user.city,
					}
				}).then(res => {
          this.is_loading = false
					if(res.data.code == 1){
						Toast(this.$t('Tips.Saved_successfully'))
						setTimeout(() =>{
              window.location.href="bogo://personals_jump";
						  //  this.$router.push({path:'/personals_conditions',query:{uid:uid, token: token }});
						},3000)
					}else{
						Toast(res.data.msg)
					}
				})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/edit_information.vue